import { render, staticRenderFns } from "./VerticalNavMenu.vue?vue&type=template&id=6c90bb6e&"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c90bb6e')) {
      api.createRecord('6c90bb6e', component.options)
    } else {
      api.reload('6c90bb6e', component.options)
    }
    module.hot.accept("./VerticalNavMenu.vue?vue&type=template&id=6c90bb6e&", function () {
      api.rerender('6c90bb6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/layout-vertical/components/vertical-nav-menu/VerticalNavMenu.vue"
export default component.exports